import { adFormats, pricingModelTypes } from '@clickadilla/components/constants'

const state = () => ({
  campaignGroups: [],
  groupId: null,
  campaignGroupsAreLoading: false,
  statuses: [
    {
      value: 'active',
      label: 'main.statuses.active',
      color: 'secondary-200',
      labelColor: 'text-black',
      icon: '$active',
      iconSize: 20,
      iconColor: 'primary'
    },
    {
      value: 'paused',
      label: 'main.statuses.paused',
      color: 'secondary-200',
      labelColor: 'text-black',
      icon: '$pause-second',
      iconColor: 'warning',
      iconSize: 20
    },
    {
      value: 'archived',
      label: 'main.statuses.archived',
      color: 'secondary-200',
      labelColor: 'text-black',
      icon: '$archived-second',
      iconColor: 'secondary-600',
      iconSize: 20
    }
  ],
  adFormates: [
    { label: 'Popunder', value: adFormats.POPUNDER },
    { label: 'Banner', value: adFormats.BANNER },
    { label: 'In-stream', value: adFormats.IN_STREAM_AD },
    { label: 'Native ad', value: adFormats.NATIVE_AD },
    { label: 'Web push', value: adFormats.WEB_PUSH },
    { label: 'Notification widget', value: adFormats.IOS_CALENDAR },
    { label: 'Gallery ', value: adFormats.GALLERY },
    { label: 'Direct link', value: adFormats.DIRECT_LINK },
    { label: 'Interstitial ', value: adFormats.INTERSTITIAL },
    { label: 'In page', value: adFormats.IN_PAGE_AD }
  ],
  pricingModels: [
    {
      label: 'CPC',
      value: pricingModelTypes.CPC,
      color: 'accent2',
      labelColor: 'text-black'
    },
    {
      label: 'CPM',
      value: pricingModelTypes.CPM,
      color: 'accent1',
      labelColor: 'text-black'
    },
    {
      label: 'CPA',
      value: pricingModelTypes.CPA,
      color: 'accent3',
      labelColor: 'text-black'
    },
    {
      label: 'CPM GOAL',
      value: pricingModelTypes.CPM_GOAL,
      color: 'accent5',
      labelColor: 'text-black'
    },
    {
      label: 'CPC GOAL',
      value: pricingModelTypes.CPC_GOAL,
      color: 'accent4',
      labelColor: 'text-black'
    }
  ],
  limitStatuses: [
    {
      value: 'hourly',
      label: 'campaign.limits_statuses.hourly_limits'
    },
    {
      value: 'daily',
      label: 'campaign.limits_statuses.daily_limits'
    },
    {
      value: 'total',
      label: 'campaign.limits_statuses.total_limits'
    }
  ],
  cpaStatuses: [
    { value: 'disabled', label: 'main.cpa_statuses.disabled', color: 'default' },
    { value: 'testing', label: 'main.cpa_statuses.testing', color: 'warning text-white' },
    { value: 'test unsuccessful', label: 'main.cpa_statuses.failed', color: 'error text-white' },
    { value: 'test successful', label: 'main.cpa_statuses.succeed', color: 'primary' }
  ],
  tablePerPagePagination: [15, 25, 50, -1]
})

export default state
